import CommonAxios from "../../Utilities/CommonAxios";
import { VendorSlice } from "../Slice/VendorSlice";
import { AgentSlice } from "../Slice/AgentSlice";
import {
    addAgent,
    agentBalancePayment, FindAgentByMobile, getAgentCollectionHistory, getAgentPromisedHistory, getAgentWalletHistory,
    getAllAgent, importNewAgent,
    promisedToCollection,
    removePromise,
    resetAgentPasswordFromAdmin,
    updateAgent,
    updatePromisedAmount
} from "../../AllRoutes/ApiRoute";
import CommonLoader from "../../Utilities/CommonLoader";
import CommonToast from "../../Utilities/CommonToast";
import Auth from "../../Utilities/Auth";

export const getAllAgentAction = payload => dispatch => {
    // getting data from payload
    const { allAgentTableLoaderRef } = payload
    //loader handle
    CommonLoader.section(allAgentTableLoaderRef)
    CommonAxios.post(getAllAgent, payload).then(res => {
        //loader handle
        CommonLoader.section(allAgentTableLoaderRef)
        if (res.data.status == true) {
            dispatch(AgentSlice.actions.getAllAgentReducer(res.data.data))
        }

    }).catch(err => {
        //loader handle
        CommonLoader.section(allAgentTableLoaderRef)
    })


}

// get agent by mobile number
export const getAgentByMobileNumberAction = payload => dispatch => {
    const { agent_id, handleFieldDisability } = payload

    handleFieldDisability(true)
    CommonAxios.post(FindAgentByMobile, payload).then(res => {
        handleFieldDisability(false)

        if (res.data?.status) {
            if (res?.data?.data && agent_id && agent_id != res?.data?.data?.id) {
                CommonToast.warning("This collector is already exist!")
            } else if (res?.data?.data && !agent_id) {
                CommonToast.warning("This collector is already exist!")
            }
        }

    }).catch(e => {
        handleFieldDisability(false)

    })
}


// add agent action
export const addAgentAction = payload => dispatch => {
    const {
        btnRef,
        setAgentAddModalShow,
        setAllAgentReload

    } = payload

    // handle button loader
    CommonLoader.btn(btnRef)


    CommonAxios.formDataPost(addAgent, payload).then(res => {
        // handle button loader
        CommonLoader.btn(btnRef)

        if (res.data.status == true) {

            // modal close
            setAgentAddModalShow(false)
            //all Agent table reload
            setAllAgentReload(prev => !prev)
            // toast
            CommonToast.success("Collector Create Successfully!")
        } else {
            CommonToast.error("Collector Create failed!")
        }

    }).catch(err => {
        // handle button loader
        CommonLoader.btn(btnRef)
    })

}

// import agent action
export const importAgentAction = payload => dispatch => {
    const {
        submitRef,
        setAllAgentReload,
        setImportModalShow
    } = payload

    // handle button loader
    CommonLoader.btn(submitRef)


    CommonAxios.post(importNewAgent, payload).then(res => {
        // handle button loader
        CommonLoader.btn(submitRef)

        if (res.data.status == true) {
            // modal close
            setImportModalShow(false)
            //all Agent table reload
            setAllAgentReload(prev => !prev)
            // toast
            CommonToast.success("Collector imported Successfully!")
        } else {
            CommonToast.error("Collector imported failed!")
        }

    }).catch(err => {
        // handle button loader
        CommonLoader.btn(submitRef)
    })

}

// update vendor action
export const updateAgentAction = payload => dispatch => {
    const {
        btnRef,
        setAllAgentReload,
        reset,
        setAgentEditModalShow

    } = payload

    // handle button loader
    CommonLoader.btn(btnRef)


    CommonAxios.formDataPost(updateAgent, payload).then(res => {
        // handle button loader
        CommonLoader.btn(btnRef)

        if (res.data.status == true) {
            // reset form
            reset()
            //Model Closw
            setAgentEditModalShow(false)

            //all Agent table reload
            setAllAgentReload(prev => !prev)
            // toast
            CommonToast.success("Agent updated Successfully!")
        } else {
            CommonToast.warning("Agent updated failed! " + res.data?.error_message)
        }

    }).catch(err => {
        // handle button loader
        CommonLoader.btn(btnRef)
    })

}


// Add Wallet action
export const addWalletAction = payload => dispatch => {
    const {
        addWalletRef,
        setAddWalletModelShow,
        setAllAgentReload,
    } = payload


    // handle button loader
    CommonLoader.btn(addWalletRef)

    CommonAxios.post(agentBalancePayment, payload).then(res => {
        CommonLoader.btn(addWalletRef)
        if (res.data.status == true) {
            setAllAgentReload(prev => prev + 1)
            setAddWalletModelShow(false)
            CommonToast.success("wallet added successfully")
        } else {
            CommonToast.error("balance added failed.")
        }
    }).catch(err => {
        CommonLoader.btn(addWalletRef)
    })
}


// Change Password action
export const changePasswordAction = payload => dispatch => {
    const {
        changePasswordRef,
        setChangePasswordModelShow,
        setAllAgentReload,

    } = payload

    // handle button loader
    CommonLoader.btn(changePasswordRef)


    CommonAxios.post(resetAgentPasswordFromAdmin, payload).then(res => {
        // handle button loader
        CommonLoader.btn(changePasswordRef)

        if (res.data.status == true) {
            // modal close
            setChangePasswordModelShow(false)
            //all Agent table reload
            setAllAgentReload(prev => !prev)
            // toast
            CommonToast.success("Password Change Successfully!")
        } else {
            CommonToast.error("Password Change Add Failed!")
        }

    }).catch(err => {
        // handle button loader
        CommonLoader.btn(changePasswordRef)
    })

}

// Promised History action
export const promisedHistoryAction = payload => dispatch => {
    const {
        btnRef,
        setPromisedDonerHistory
    } = payload

    try {
        // handle button loader
        CommonLoader.btn(btnRef)
    } catch (error) {

    }

    // db operation
    CommonAxios.post(getAgentPromisedHistory, payload).then(res => {
        try {
            // handle button loader
            CommonLoader.btn(btnRef)
        } catch (error) {

        }
        if (res.data.status == true) {
            setPromisedDonerHistory(res.data.data)


        } else {
            // CommonToast.error("balance added failed.")
        }
    }).catch(err => {
        try {
            // handle button loader
            CommonLoader.btn(btnRef)
        } catch (error) {

        }
    })
}

// Promised to collection
export const promisedToCollectionAction = payload => dispatch => {
    const {

        setPromisedToCollectionSingle,
        setPromisedToCollectionModelShow,
        setPromisedDonerHistory
    } = payload



    // db operation
    CommonAxios.post(promisedToCollection, payload).then(res => {


        if (res.data.status == true) {
            const user_detail = JSON.parse(Auth.header().userdetail)

            //Model Close
            setPromisedToCollectionModelShow(false)
            setPromisedToCollectionSingle({})

            dispatch(promisedHistoryAction({
                setPromisedDonerHistory,
                data: {
                    agent_id: user_detail?.is_admin ? "" : user_detail?.id,
                    row_count: 200
                },
            }))
            CommonToast.success(res?.data?.message || "Promise resolved successfully!")

        } else {
            CommonToast.error(res.data?.message || "something went wrong. try again.")
        }
    }).catch(err => {
        // handle button loader

    })
}

// update promised amount action
export const updatePromisedAmountAction = payload => dispatch => {
    const { btnRef, setPromiseEditModal, setPromisedReload } = payload

    // handle button disability
    CommonLoader.btn(btnRef)
    // db operation
    CommonAxios.post(updatePromisedAmount, payload).then(res => {
        // handle button disability
        CommonLoader.btn(btnRef)

        if (res?.data?.status) {
            setPromiseEditModal(false)
            setPromisedReload(prev => !prev)
            CommonToast.success(res?.data?.message || "Updated successfully.")
        } else {
            CommonToast.error(res?.data?.message || "Update failed")
        }

    }).catch(err => {
        // handle button disability
        CommonLoader.btn(btnRef)
    })

}

// delete promise action
export const deletePromiseAction = payload => dispatch => {
    const { setPromisedReload,
        setPromiseDeleteModal,
        btnRef } = payload

    // handle button disability
    CommonLoader.btn(btnRef)
    // db operation
    CommonAxios.post(removePromise, payload).then(res => {
        // handle button disability
        CommonLoader.btn(btnRef)

        if (res?.data?.status) {
            setPromiseDeleteModal(false)
            setPromisedReload(prev => !prev)
            CommonToast.success(res?.data?.message || "Removed successfully.")
        } else {
            CommonToast.error(res?.data?.message || "Remove failed")
        }

    }).catch(err => {
        // handle button disability
        CommonLoader.btn(btnRef)
    })

}


// Agent Wallet History action
export const agentWalletHistoryAction = payload => dispatch => {
    const {
        btnRef,
        setAgentWalletHistory
    } = payload

    // handle button loader
    CommonLoader.btn(btnRef)

    // db operation
    CommonAxios.post(getAgentWalletHistory, payload).then(res => {
        // handle button loader
        CommonLoader.btn(btnRef)

        if (res.data.status == true) {
            setAgentWalletHistory(res.data.data)


        } else {
            // CommonToast.error("balance added failed.")
        }
    }).catch(err => {
        // handle button loader
        CommonLoader.btn(btnRef)
    })
}


// Agent Collection History action
export const agentCollectionHistoryAction = payload => dispatch => {
    const {
        btnRef,
        setAgentCollectionHistory
    } = payload

    // handle button loader
    CommonLoader.btn(btnRef)

    // db operation
    CommonAxios.post(getAgentCollectionHistory, payload).then(res => {
        // handle button loader
        CommonLoader.btn(btnRef)

        if (res.data.status == true) {
            setAgentCollectionHistory(res.data.data)


        } else {
            // CommonToast.error("balance added failed.")
        }
    }).catch(err => {
        // handle button loader
        CommonLoader.btn(btnRef)
    })
}


